import { Component, OnInit } from '@angular/core';
import { IBasicOrganisationInfo } from '../../../interfaces/telephony/basic-organisation-info';
import { EventService, OrganisationsService } from '../../../services';
import { OrganisationSelectorEventTypeEnum } from '../../../interfaces/telephony/organisation-selector-event-type.enum';
import { IOrganisationSelectorEvent } from '../../../interfaces/telephony/organisation-selector-event';
import { OrganisationTypeEnum } from '../../../enums/organisation-types';

@Component({
  selector: 'add-number-organisation-search',
  templateUrl: './add-number-organisation-search.component.html',
  styleUrls: ['./add-number-to-organisation.component.scss'],
})
export class AddNumberOrganisationSearchComponent implements OnInit {
  allOrganisationInfos: IBasicOrganisationInfo[];
  organisationInfos: IBasicOrganisationInfo[];
  searchText: any;

  hoverMore: number;

  orgStatusOptions: {}[] = [
    { value: null, label: 'View All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Deactivated' },
  ];
  orgStatus: any;
  orgStatusName = { false: 'active', true: 'deactivated' };

  orgTypeOptions: {}[] = [
    { value: null, label: 'View All Organisations' },
    { value: 'customer', label: 'Customers' },
    { value: 'supplier', label: 'Suppliers' },
  ];
  orgType: any;
  selectedRow: number = -1;

  constructor(private orgService: OrganisationsService, private eventService: EventService) {
    this.eventService.OrganisationSelectorEvent.subscribe((event: IOrganisationSelectorEvent) => {
      if (event.eventType == OrganisationSelectorEventTypeEnum.OpenAddNumberSelector) {
        // load all organisation information once on start
        if (this.allOrganisationInfos == null || this.allOrganisationInfos.length == 0) {
          this.loadOrganisationInfo();
        }

        // focus on input
        setTimeout(() => {
          let element = document.getElementById('orgNameInput');
          if (element) {
            element.focus();
          }
        }, 150);
      }
    });
  }

  ngOnInit() {}

  loadOrganisationInfo() {
    // load all organisation information once on start
    this.orgService.getCurrentUserOrgTypeId().then((id) => {
      if (id != OrganisationTypeEnum.Engineius) {
        return;
      }
      this.orgService.getBasicInfos().then((results) => {
        this.allOrganisationInfos = results;
      });
    });
  }

  searchTextChanged(text) {
    text = text || '';

    let search = text.toLowerCase().trim();
    this.searchText = search;

    // filter the current results by name when 3 chars or more
    if (search && search.length >= 3) {
      this.filterResults();
    }
  }

  filterResults() {
    let inactive = this.orgStatus == 'inactive';
    let orgType =
      this.orgType == 'customer' ? OrganisationTypeEnum.Customer : OrganisationTypeEnum.Supplier;

    this.organisationInfos = this.allOrganisationInfos.filter(
      (x) =>
        (x.organisationTypeId == orgType || !this.orgType) &&
        (x.inactive == inactive || !this.orgStatus) &&
        ((x.name && x.name.toLowerCase().indexOf(this.searchText) >= 0) ||
          (x.emailAddress && x.emailAddress.toLowerCase().indexOf(this.searchText) >= 0) ||
          (x.phoneNumber && x.phoneNumber.indexOf(this.searchText) >= 0) ||
          (x.organisationPhoneNumbers &&
            x.organisationPhoneNumbers.filter(
              (y) => y.phoneNumber && y.phoneNumber.indexOf(this.searchText) >= 0,
            ).length > 0)),
    );
  }

  organisationSelected(org: IBasicOrganisationInfo, i: number) {
    this.selectedRow = i;

    let eventType =
      org.users?.length > 1
        ? OrganisationSelectorEventTypeEnum.OpenUserSelector
        : OrganisationSelectorEventTypeEnum.AssociateOrganisationSelected;

    this.eventService.OrganisationSelectorEvent.emit({
      eventType: eventType,
      args: { selectedOrg: org },
    });
  }

  orgTypeChange(orgType: any) {
    this.orgType = orgType;
    this.filterResults();
  }

  orgStatusChange(orgStatus: any) {
    this.orgStatus = orgStatus;
    this.filterResults();
  }
}
